export default "__VITE_ASSET__CzG9teTn__"